//
// Utility Plugin for setting the configuration
//
import { pluginFactory } from './utils/plugins';
export var BVConfigPlugin =
/*#__PURE__*/
pluginFactory();


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/bv-config.js
// module id = 425
// module chunks = 0 1 2 3 4 5 6 7